import { IApplicationState } from '../../types/redux';

export const getPriceAndQualityBalanceRating = (state: IApplicationState): number | null => {
  return state.newReview.data.priceAndQualityBalanceRating.value;
};
